import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import {
  BUILDING_FORM_BANK_NAME_FIELD_MAX_LENGTH,
  BUILDING_FORM_FIELD_NAME_BANK_NAME,
} from '../../BuildingForm.constants'

function BankNameField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Building.BankNameLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      maxLength={BUILDING_FORM_BANK_NAME_FIELD_MAX_LENGTH}
      name={BUILDING_FORM_FIELD_NAME_BANK_NAME}
      placeholder={t('Building.BankNamePlaceholderKey')}
    />
  )
}

export default BankNameField
